<template>
  <div class="fob-entity-compact columns">
    <div class="column is-narrow fob-hide-in-print" style="width: 5rem">
      <b-field addon>
        <router-link class="control"
          :to="{ name: entityDetailsRoute,
                params: {
                  resourceType,
                  resourceId
                }
              }"
        >
          <b-tooltip square position="is-top" :label="$gettext('component.entity.compact.details')">
            <b-icon icon="search" type="is-aquamarine"></b-icon>
          </b-tooltip>
        </router-link>
        <router-link class="control"
          v-if="userCanEditByKostenstelle(data)"
          :to="{ name: entityEditRoute,
                params: {
                  resourceType,
                  resourceId
                }
              }"
        >
          <b-tooltip square position="is-top" :label="$gettext('component.entity.compact.edit')">
            <b-icon icon="edit" type="is-aquamarine"></b-icon>
          </b-tooltip>
        </router-link>
        <span
          v-if="showStar"
          style="cursor: pointer;"
          @click="favourResearchActivity({
            resourceType,
            resourceId
          })"
        >
          <b-tooltip
            square
            position="is-top"
            :label="isFavouredResearchActivity({resourceType,resourceId}) ?
              $gettext('component.entity.compact.favour.deselect') :
              $gettext('component.entity.compact.favour.select')"
          >
            <b-icon :icon="isFavouredResearchActivity({resourceType,resourceId}) ? 'star' : 'star-o'" type="is-aquamarine"></b-icon>
          </b-tooltip>
        </span>
      </b-field>
    </div>
    <div class="column">
      <component
        class="fob-entity-compact-component"
        v-if="hasCompactComponent"
        :is="compactComponentName"
        :schema="schema"
        :data="data"
      ></component>
      <div v-else>
        {{ data._stringRep }}
      </div>
    </div>
    <div v-if="showPublicationType" class="fob-hide-in-print">
      <translate class="tag is-aquamarine">{{`PublikationsTyp.${data.publikationsTyp}`}}</translate>
    </div>
  </div>
</template>

<script>
import ForschungsprojektCompact from '@/components/compact/Forschungsprojekt'
import PatentCompact from '@/components/compact/Patent'
import PublikationCompact from '@/components/compact/Publikation'
import PreisCompact from '@/components/compact/Preis'
import KooperationCompact from '@/components/compact/Kooperation'
import VeranstaltungCompact from '@/components/compact/Veranstaltung'
import UserCanEditByKostenstelle from '@/components/mixins/UserCanEditByKostenstelle'
import FavourResearchActivity from '@/components/mixins/FavourResearchActivity'

export default {
  name: 'fob-entity-compact',
  mixins: [UserCanEditByKostenstelle, FavourResearchActivity],
  props: ['schema', 'data', 'entityDetailsRoute', 'entityEditRoute', 'showPublicationType', 'showStar'],
  computed: {
    hasCompactComponent () {
      return `fob-${this.schema.className}-compact` in this.$options.components
    },
    compactComponentName () {
      return `fob-${this.schema.className}-compact`
    },
    resourceType () {
      return this.data._entityName.split('.').splice(-1)[0].toLowerCase()
    },
    resourceId () {
      return this.data._id
    }
  },
  components: {
    'fob-forschungsprojekt-compact': ForschungsprojektCompact,
    'fob-patent-compact': PatentCompact,
    'fob-publikation-compact': PublikationCompact,
    'fob-preis-compact': PreisCompact,
    'fob-kooperation-compact': KooperationCompact,
    'fob-veranstaltung-compact': VeranstaltungCompact
  }
}
</script>

<style>
  .fob-entity-compact-component {
    page-break-after: avoid;
    display: inline-block;
    vertical-align: bottom;
  }
 .fob-compact-item-title {
   font-weight: bold;
 }
 .fob-compact-item-key {
   font-style: italic;
   padding-right: 5px;
 }
</style>



// WEBPACK FOOTER //
// src/components/EntityCompact.vue